<template>
  <div class="result single-step">
    <!-- TODO добавить переводы -->

    <!-- <div class="top-block">
      <div class="summary">
        <div class="heading">
          <h2>Summary</h2>
        </div>

        <p>
          <b>{{ $ml.get('farm') }}:</b>
          {{ ( $store.getters['farms/farms'].find(x => x.id == $store.getters['program/data'].farmId) ).name }}
        </p>
        <p>
          <b>{{$ml.get('field')}}: </b>
          {{ ( $store.getters['farms/fields'].find(x => x.id == $store.getters['program/data'].fieldId) ).name }}
        </p>
        <p>
          <b>{{$ml.get('FIELD AREA, ha')}}: </b>
          {{ ( $store.getters['farms/fields'].find(x => x.id == $store.getters['program/data'].fieldId) ).area }}
        </p>
        <p>
          <b>{{$ml.get('crop')}}: </b>
          {{ ( $store.getters['user-crops/data'].find(x => x.id == $store.getters['program/data'].baseCropId).name ) }}
        </p>
        <p>
          <b>Program Type: </b>
          {{ $store.getters['program/data'].type }}
        </p>
      </div>

      <PagesWhitelist :pages="pages"/>
    </div> -->

    <!-- <div v-if="$store.getters['program/isFinished'] && $store.getters['user/plan'] == 'impact'"></div> -->

    <top-info/>
    <fertilizer-summary v-if="program.finished"/>

    <transition name="modal-fade-scale">
      <download-report-modal
        v-if="opened.download"
        @close="closeDownloadModal"
      />
    </transition>
    <transition name="modal-fade-scale">
      <finish-program-modal
        v-if="opened.finish"
        @close="closeFinishModal"
      />
    </transition>

    <div class="actions">
      <app-btn
        v-if="!program.finished"
        @click="openFinishModal"
      >{{$ml.get('Finish')}}</app-btn>

      <app-btn
        v-else
        @click="openDownloadModal"
        :disabled="!numOfReports.is_available"
      >{{$ml.get('Download')}} {{$ml.get('Report')}} (PDF)</app-btn>

      <app-btn
        v-if="$store.getters['user/data'].globalRole == 'admin'"
        @click="downloadAdmin"
        >
        download without saving(admin)
      </app-btn>

      <app-btn
        v-if="program.finished"
        @click="downloadExcel"
        >
        {{ $ml.get(`Download as Excel`) }}
      </app-btn>

    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import DownloadReportModal from './DownloadReportModal'
import FinishProgramModal from './FinishProgramModal'
import TopInfo from './TopInfo'
import FertilizerSummary from './FertilizerSummary'
export default {
  data() {
    return {
      loading: {
        finish: false,
        download: false,
      },
      opened: {
        download: false,
        finish: false,
      },
    }
  },

  components: {
    DownloadReportModal,
    FinishProgramModal,
    TopInfo,
    FertilizerSummary,
  },

  methods: {

    openDownloadModal() {
      this.opened.download = true;
    },

    closeDownloadModal() {
      this.opened.download = false;
    },

    openFinishModal() {
      this.opened.finish = true;
    },

    closeFinishModal() {
      this.opened.finish = false;
    },

    downloadAdmin() {

      API.pdf.getAdminPdf(this.$route.params.programId)
        .then(res => {
          var blob = new Blob([ res.data ], { type: 'application/pdf' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$store.getters['program/data'].name + '.pdf';
          link.click();
          // this.$store.dispatch('user/availableReports');
          // this.close();
        })
    },

    downloadExcel() {
      return API.pdf.getExcel(this.$route.params.programId)
      .then(res => {
        var blob = new Blob([ res.data ], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const program_name = this.$store.getters['program/data'].name;
        link.download = `Smart Fertilizer UK - ${program_name}.xlsx`;
        link.click();
        // this.$store.dispatch('user/availableReports');
        // this.close();
      })
    }
  },

  computed: {
    ...mapGetters({
      numOfReports: 'user/availablePrograms',
      program: 'program/data',
    }),
  },
}
</script>

<style lang="scss" scoped>

.result {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // .heading {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;



  .actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .app-btn {
      margin-left: 20px;
    }
  }

  .top-block {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    padding-bottom: 30px;
  }

}

</style>
